module.exports = __webpack_public_path__ + "static/media/InviteMerchant.89f5d131.png";